import { Typography, Link } from "@mui/material";

export function BottomNavbar(props) {
 return (
  <Typography
   variant="body2"
   color="text.secondary"
   align="center"
   sx={{ mt: 6 }}
   {...props}
  >
   {"Copyright © "}
   <Link color="inherit" href={process.env.REACT_APP_MAIN_URL}>
    {process.env.REACT_APP_NAME}
   </Link>{" "}
   {new Date().getFullYear()}
   {"."}
  </Typography>
 );
}
